import * as tagUtil from "./LogTagData";

const forgetPasswordSuccessEvent = () => {
    let data = {
        page_event: "view",
        service_application_event: "finish",
        service_application_step: "ebu: self service: forgot password success",
        service_application_name: "ebu: self service: forgot password (transaction)",
        service_application_type: "transaction",
        page_name: "ebu: self service: forgot password: success"
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgetPasswordErrorEvent = (err) => {
    let data = {
        page_form_event: "error",
        page_errors: err,
        page_name: "ebu: self service: forgot password: journey error"
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgetPasswordPageLoad = () => {
    let data = {
        page_event: "view",
        service_application_event: "start",
        service_application_step: "ebu: self service: forgot password",
        service_application_name: "ebu: self service: forgot password (transaction)",
        service_application_type: "transaction",
        page_name: "ebu: self service: forgot password"
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgetPasswordOtpPageLoad = () => {
    let data = {
        page_event: "view",
        service_application_step: "ebu: self service: forgot password: enter otp",
        service_application_name: "ebu: self service: forgot password (transaction)",
        service_application_type: "transaction",
        page_name: "ebu: self service: forgot password: enter otp"
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgetPasswordReOtpPageLoad = () => {
    let data = {
        page_event: "view",
        service_application_step: "ebu: self service: forgot password: re-enter otp",
        service_application_name: "ebu: self service: forgot password (transaction)",
        service_application_type: "transaction",
        page_name: "ebu: self service: forgot password: re-enter otp"
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgetPasswordOtpErrorEvent = (err) => {
    let data = {
        page_form_event: "error",
        page_errors: err,
        page_name: "ebu: self service: forgot password: journey error"
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgetPasswordRegisterEvent = (url) => {
    let data = {
        link_type : "o",
        link_name : "ebu: self service: forgot password: register ",
        link_url : url
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};


export {
    forgetPasswordPageLoad,
    forgetPasswordSuccessEvent,
    forgetPasswordErrorEvent,
    forgetPasswordOtpPageLoad,
    forgetPasswordReOtpPageLoad,
    forgetPasswordOtpErrorEvent,
    forgetPasswordRegisterEvent
};
